<template>
    <el-table
        stripe
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="headCellStyle"
        :cell-style="bodyCellStyle"
        :height="tableHeight"
        @selection-change="handleSelectionChange"
    >
        <el-table-column type="selection" width="55" />
        <el-table-column prop="sceneName" :label="$t('labelTitle.Range')" v-if="isSysAdmin" show-overflow-tooltip />
        <el-table-column :label="$t('detection.mInterval')" show-overflow-tooltip prop="name" />
        <el-table-column :label="$t('detection.intervalValue')" show-overflow-tooltip prop="rangeText">
            <template #default="{ row }">
                <span>{{ formatTempValue(row.min,row.unitId)  }} {{ fomatUnit(row.unitId) }}</span>
                <span> ~ </span>
                <span>{{  formatTempValue(row.max,row.unitId) }} {{ fomatUnit(row.unitId) }}</span>
            </template>
        </el-table-column>
        <el-table-column :label="$t('tableTitle.Creation Time')" show-overflow-tooltip prop="createTime">
            <template #default="{ row }">{{ $timetransition(row.createTime) }}</template>
        </el-table-column>
        <el-table-column :label="$t('tableTitle.Operating')" width="120px" prop="name">
            <template #default="{ row }">
                <el-button type="text" icon="el-icon-edit-outline" size="small" :title="$t('buttonTitle.Edit')" v-has="['uptRange']" @click="handleCompile(row)"></el-button>
                <el-button @click="delsMonitor(row)" :title="$t('buttonTitle.Delete')" icon="el-icon-delete" type="text" size="small" v-has="['delRange']"></el-button>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import { TempUtils } from '@/utils/TempUtil.js';

export default {
    props: ['UnitMeasurement','loading', 'tableData'],
    computed: {
        isSysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            return (currentUser.sysScope && currentUser.sysAdmin) || (currentUser.sysScope && !currentUser.sysAdmin);
        }
    },
    data() {
        return {
            tableHeight: 'calc(100% - 60px)'
        };
    },
    methods: {
      formatTempValue (val, unitId) {
        if (val === null || val === undefined || val === '') return '--'
        const numVal = Number(val)
        if (isNaN(numVal)) return '--'
        const index = this.UnitMeasurement.findIndex(item => item.id === unitId);
        const result = TempUtils.convertToCelsius(numVal, this.UnitMeasurement[index].name)
        const finalVal = isNaN(result) ? '--' : Number(result).toFixed(2)
        return `${finalVal}`
      },
      fomatUnit(unitId){
        const index = this.UnitMeasurement.findIndex(item => item.id === unitId);
        const finalUnit = this.UnitMeasurement[index].name;
        return `${finalUnit}`
      },
      handleSelectionChange (arg) {
        this.$emit('choozeTableFn', arg)
      },
      handleCompile (row) {
        this.$emit('editRow', row)
      },

      delsMonitor ({
        id,
        type
      }) {
        // const OBJ = Object.create(null);
        // let str = "tAry";
        // if (type === 1) { str = "hAry" };

        // OBJ[str] = this.$getCaption(id, 0)
        this.$parent.TODOTIPDEL({ ids: id })
      }
    }
};
</script>

<style></style>
